<template>
  <div></div>
</template>

<script>
export default {
  name: 'OverlayQrCode',
  props: {
    text: String,
    url: String
  },
  created() {
    const h = this.$createElement
    this.$msgbox({
      message: h('div', [
        h('div', { attrs: { class: 'flex items-center' } }, [
          h('img', { attrs: { src: '/assets/img/common/weixin.png', width: '16', class: 'mr-1' } }),
          h('span', { attrs: { class: 'text-medium text-theme-black-650 align-middle' } }, this.text)
        ])
        // h('div', { attrs: { class: 'text-center' } }, [
        //   h('img', { attrs: { src: this.url, width: '120', height: '120' } })
        // ])
      ]),
      showClose: false,
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickModal: false
    })
  }
}
</script>
